import axios from 'axios'
import { setCookie, deleteCookie, getToken } from '../Cookies/cookies'
import config from '../../config';

const strapiUrl =process.env.REACT_APP_STRAPI_URL?.split('/')?.[2]

function getLoginUri() {
  return process.env.REACT_APP_LOGIN_URL + btoa(window.location.href) + "&isRegUser=1";
}

axios.interceptors.request.use(function (config) {
  const Token = getToken(true);
  const configUrl = config?.url?.split('/')?.[2]
  const validateApi= configUrl == strapiUrl ? true : false
  // const Token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wIjoidHJhZGVidWxscyIsInN1YiI6IjEyMzQiLCJyb2xlIjoiU0UiLCJlbXBDb2RlIjoiMTIzNCIsInVzZXJfbmFtZSI6IjEyMzQiLCJzY29wZSI6WyJhbGwiXSwiZXhwIjoxNTcxNjM3NjkwLCJpYXQiOjE1NjYzODE2OTAsImF1dGhvcml0aWVzIjpbIjEyMzQiLCJTRSJdLCJqdGkiOiI1YTFkOWQ0OS01OWUxLTQzODQtYmI0OC1hZDFjZGQxMzgxN2QiLCJjbGllbnRfaWQiOiJ0cmFkZWJ1bGxzIn0.6bLqu0P03JZVpSEOmW6ntdq9xQDc8AwupNnBcgRzqhs"
  // Objection Token 
  // const Token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wIjoidHJhZGVidWxscyIsInN1YiI6IkU3NTY1Iiwicm9sZSI6IlNFIiwiZW1wQ29kZSI6IkU3NTY1IiwidXNlcl9uYW1lIjoiRTc1NjUiLCJzY29wZSI6WyJhbGwiXSwiZXhwIjoxNTczNTIzMTg3LCJpYXQiOjE1NjgyNjcxODcsImF1dGhvcml0aWVzIjpbIkU3NTY1IiwiU0UiXSwianRpIjoiMzQ3YTI4ZWMtMTgwNi00MGYxLThiYTYtMjI2MzMzODFlMzQzIiwiY2xpZW50X2lkIjoidHJhZGVidWxscyJ9.jRBVrmxt3XICfjhP_2w0gBz9CydpPCMOIBcxZnje6bs"
  // Dev Token 
  // const Token ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wIjoidHJhZGVidWxscyIsInN1YiI6IjEyMzQiLCJyb2xlIjoiMCIsInVzZXJfbmFtZSI6IjEyMzQiLCJzY29wZSI6WyJlbnRlcnByaXNlIl0sImV4cCI6MjE2OTkzMjg3MCwiaWF0IjoxNTY5OTMyODcwLCJhdXRob3JpdGllcyI6WyIwIl0sImp0aSI6IjQ4MTViMmZmLWMzYmItNGQxZi1hZmJjLTJkNTVmNzY5ZmFjYyIsImNsaWVudF9pZCI6InRic2VudGVycHJpc2V3ZWIifQ.tELCKpBknmVJ6L9m5bUZD1OU0OHhlpy9dqoCo2mgXOM"
  let Authorization;
  if (Token)
    Authorization = "Bearer " + (validateApi ? "" : Token);

  const req_info = { "rit": "123", "cver": "1.0v", "ch": "web", "info": { "signUpChannnel": "DIY" }, "reqts": "" }

  config.headers = {
    "request-info": JSON.stringify(req_info),
    'Content-Type': 'application/json',
    Authorization,
    ...config.headers
  }
  if (!Token || Token == "") {
    delete config.headers.Authorization
  }
  if (!config.auth) {
    if (!isFormData(config.data)) {
      config.data = {
        "payload": Array.isArray(config.data) ? config.data : [config.data]
      }
    }
  }
  else {
    delete config.auth
    delete config.headers.Authorization
  }
  return config;
}, function (error) {
  console.log(error.message)
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {

  if (response.status === 401) {
    // window.location.href=URIConstants.loginPage
    window.location.href = getLoginUri();
  }

  return response.data;

}, function (error) {
  console.log(error)
  if (error.message && error.message.includes("401")) {
    // window.location.href=URIConstants.loginPage+"?referer="+btoa(window.location.href)
    window.location.href = getLoginUri();
  }
  return Promise.reject(error);
});

function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
export default axios;


export const tokenReInitializer = function (expiry) {
  /*if(getToken())
 if(getCookie("refresh_token")){
 reInit().then(({data:{success}}) => {
     localStorage.setItem('access_token', JSON.stringify(success));
     /* setCookie("token", success.access_token, "/") /
     document.cookie="token="+success.access_token+";secure;"
     //document.cookie="refresh_token="+success.access_token+";secure;"
     setCookie("token", success.access_token, "/")
     //setCookie("refresh_token", success.refresh_token, "/")
     // setCookie("refresh_token", success.refresh_token, "/")
     // console.log("Cookie Set:", resp.access_token)
     var tkDetail=JSON.parse(atob(success.access_token.split(".")[1]))
     setTimeout(tokenReInitializer.bind(null,tkDetail.exp-tkDetail.iat-100) , (tkDetail.exp-tkDetail.iat-100)*1000)
     //setTimeout(tokenReInitializer.bind(null,tkDetail.exp-tkDetail.iat-10) , expiry)
   })
 } */
}
if (getToken(true)) {
  setTimeout(() => tokenReInitializer(1000), 5000)

}
function reInit() {
  return axios.post(process.env.REACT_APP_API_URL + config.refreshToken, "grant_type=refresh_token&refresh_token=" + getToken() + "&clientId=tbslmsmobile", { auth: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
}